import { useTranslation } from 'react-i18next';

import { $FIXME } from '../../constants';
export interface IUserDataResquestType {
    fullName: string;
    phoneNumber: {
        number: string;
        code: string;
    };
    category: string;
    subCategory?: string;
}
export const NoCarFound = (props: $FIXME) => {
    const { t } = useTranslation();
    return (
        <section className="section-wrapper py-3">
            <div className="container">
                <div className="flex-container">
                    <div className="custom-image">
                        <img
                            src="/images/request-car.webp"
                            alt="Vehicle search illustration"
                        />
                    </div>
                    <div className="content-column">
                        <div className="text-content">
                            <h6>{t('vehicleNotFound.title')}</h6>
                            <p>{t('vehicleNotFound.description')}</p>
                        </div>
                        <div className="button-container">
                            <a href="/request-car" className="button">
                                {t('vehicleNotFound.sendRequirement')}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
